import { render, staticRenderFns } from "./KDivider.vue?vue&type=template&id=213efaae&"
import script from "./KDivider.vue?vue&type=script&lang=js&"
export * from "./KDivider.vue?vue&type=script&lang=js&"
import style0 from "./KDivider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports